import { render, staticRenderFns } from "./AseanCpaPengajuanRekomendasi.vue?vue&type=template&id=32221f46&"
import script from "./AseanCpaPengajuanRekomendasi.vue?vue&type=script&lang=js&"
export * from "./AseanCpaPengajuanRekomendasi.vue?vue&type=script&lang=js&"
import style0 from "./AseanCpaPengajuanRekomendasi.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports